import TNTControlBase from '../../util/TNTControlBase';

class LocationZoneController extends TNTControlBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "location_zone";
        this.acl = {};
        this.hasACL = {};
    }

    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_control_' + this.id]) {
            this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
        }
    }
}

export default LocationZoneController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/location_zone.controller.js